import { useEffect } from "react";
import { Link, Navigate } from "react-router-dom";
import { ArrowLeft, ArrowDown, History, Loader2, LogOut, RefreshCw } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Alert, AlertDescription } from "@/components/ui/alert";
import { useAuth } from "@/lib/AuthContext";
import { useAccessHistory } from "@/components/access-history/useAccessHistory";
import { AccessHistoryTable } from "@/components/access-history/AccessHistoryTable";
import "@/components/access-history/access-history.css";

export default function AccessHistory() {
  const { logout } = useAuth();
  const history = useAccessHistory();
  useEffect(() => {
    const previousTitle = document.title;
    document.title = "Istoric acces · Ivory Pulse";
    window.scrollTo({ top: 0, behavior: "instant" });
    return () => { document.title = previousTitle; };
  }, []);
  if (history.error?.status === 403) return <Navigate to="/" replace />;

  return (
    <div className="access-history-page" data-testid="access-history-page" lang="ro">
      <header className="access-history-header">
        <div className="access-history-width">
          <Link to="/" data-testid="access-history-home" aria-label="Înapoi la Ivory Pulse"><ArrowLeft size={18} aria-hidden="true" /><img src={`${process.env.PUBLIC_URL}/logo.png`} alt="Ivory Pulse" className="brand-invert" /></Link>
          <Button variant="ghost" onClick={logout} data-testid="access-history-logout"><LogOut size={16} aria-hidden="true" /><span>Deconectare</span></Button>
        </div>
      </header>
      <main className="access-history-width access-history-main">
        <div className="access-history-heading">
          <p className="access-history-eyebrow" data-testid="access-history-admin-label">Administrare</p>
          <h1 data-testid="access-history-title">Istoric acces</h1>
          <p className="access-history-subtitle" data-testid="access-history-subtitle">Autentificări reușite, de la cea mai recentă.</p>
        </div>
        <div className="access-history-toolbar">
          <p data-testid="access-history-timezone">Ora României <span>Europe/Bucharest</span></p>
          <Button variant="outline" onClick={history.refresh} disabled={!!history.pending} data-testid="access-history-refresh"><RefreshCw size={16} className={history.pending === "initial" ? "access-history-spin" : ""} aria-hidden="true" /><span>{history.pending === "initial" ? "Se actualizează…" : "Actualizează"}</span></Button>
        </div>
        {history.error && (
          <Alert className="access-history-error" data-testid="access-history-error">
            <AlertDescription data-testid="access-history-error-message">{history.error.message}</AlertDescription>
            {history.error.status === 401 && <Button variant="outline" onClick={logout} data-testid="access-history-reauth">Autentificare</Button>}
          </Alert>
        )}
        {history.events.length > 0 && <AccessHistoryTable events={history.events} pending={history.pending} />}
        {history.pending && history.events.length === 0 && <div className="access-history-placeholder" role="status" data-testid="access-history-loading"><Loader2 className="access-history-spin" size={24} aria-hidden="true" /><p>Se încarcă istoricul…</p></div>}
        {!history.pending && !history.error && history.events.length === 0 && <div className="access-history-placeholder" data-testid="access-history-empty"><History size={32} strokeWidth={1.25} aria-hidden="true" /><p>Nicio autentificare înregistrată încă.</p></div>}
        <div className="access-history-bottom">
          <p data-testid="access-history-count" role="status">{history.events.length} {history.events.length === 1 ? "conectare afișată" : "conectări afișate"}</p>
          {history.nextCursor && <Button variant="outline" onClick={history.loadMore} disabled={!!history.pending} data-testid="access-history-load-more">{history.pending === "more" ? <Loader2 className="access-history-spin" size={16} aria-hidden="true" /> : <ArrowDown size={16} aria-hidden="true" />}{history.pending === "more" ? "Se încarcă…" : "Conectări mai vechi"}</Button>}
        </div>
        <p className="access-history-coverage" data-testid="access-history-coverage">Istoric disponibil doar de la activarea jurnalului.</p>
      </main>
    </div>
  );
}